<template>
  <div class="pagination-page-box">
    <el-pagination
      v-if="total !== 0"
      ref="paginationPage"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="currentPageNow"
      :page-size="pageSize"
      :page-sizes="[1, 10, 20, 50, 100, 200, 500]"
      @current-change="currentChange"
      @size-change="sizeChange"
    />
  </div>

</template>

<script>
export default {
  name: 'PaginationPage',
  components: {},
  props: {
    // 分页数据条数
    total: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    // 页码改变调用 function(currentPage, pageSize)
    changeFun: {
      type: Function
    }
  },
  data() {
    return {
      currentPageNow: 1,
      pageSize: 10
    }
  },
  watch: {
    currentPage() {
      this.currentPageNow = this.currentPage
    }
  },
  mounted() {
    const self = this
    window.paginationPage = self
  },
  methods: {
    /**
    * 选中分页
    */
    currentChange(val) {
      this.currentPageNow = val
      this.changeFun(this.currentPageNow, this.pageSize)
      console.log('当前页', this.currentPageNow)
    },

    /**
    * 修改每页条数
    */
    sizeChange(val) {
      this.pageSize = val
      this.currentPageNow = 1
      this.changeFun(this.currentPageNow, this.pageSize)
      console.log('条数', this.pageSize)
    }
  }
}
</script>

<style lang="scss">
  .pagination-page-box {
    .tabAction {
      .el-tooltip {
        /*.textBtn {*/
        /*  float: left;*/
        /*  color: #409eff;*/
        /*  margin-right: 6px;*/
        /*}*/
      }
    }

    .el-pagination {
      margin-top: 20px;

      .el-pagination__total, .el-input--mini .el-input__inner, .el-pagination__editor.el-input .el-input__inner {
        height: 35px;
        line-height: 35px;
      }

      .el-pager {
        li {
          padding: 0;
          min-width: 35px;
          height: 35px;
          line-height: 35px;
          margin: 0 5px;
          color: rgba(0, 0, 0, 0.65);
          border: 1px solid rgba(217, 217, 217, 1);
          border-radius: 5px;
        }

        .active {
          background-color: #409eff;
          color: #ffffff;
          border-color: #409eff;
        }
      }

      .btn-prev,
      .btn-next {
        width: 35px;
        height: 35px;
        color: #000000;
        border: 1px solid rgba(217, 217, 217, 1);
      }

      .btn-prev {
        padding-right: 6px;
        margin-right: 5px;
      }

      .btn-next {
        padding-left: 6px;
        margin-left: 5px;
      }
    }
  }
</style>
